module.exports = __webpack_public_path__ + "static/media/loading.49bcdcc1.svg";